import { useState, useEffect } from 'react';
import { AudioTrack } from '../types';

const AUDIO_TRACKS: AudioTrack[] = [
  {
    id: 'track-1',
    title: 'Glory to God on High',
    path: '/audio/Glory to God on High.mp3'
  },
  {
    id: 'track-2',
    title: 'CeCe Winans - Come Jesus Come',
    path: '/audio/CeCe Winans - Come Jesus Come (Official Video).mp3'
  },
  {
    id: 'track-3',
    title: 'Jireh Live (Feat. Keke Louis & Angelo Felix)',
    path: '/audio/Jireh Live (Feat. Keke Louis & Angelo Felix).mp3'
  },
  {
    id: 'track-4',
    title: 'O Come to the Altar - Live - Elevation Worship',
    path: '/audio/O Come to the Altar _ Live _ Elevation Worship.mp3'
  },
  {
    id: 'track-5',
    title: 'YET - Maverick City Music',
    path: '/audio/YET - Maverick City Music _ Chandler Moore _ Ashley Hess _ the King will come (Official Music Video).mp3'
  }
];

export function useAudioTracks() {
  const [tracks, setTracks] = useState<AudioTrack[]>([]);

  useEffect(() => {
    setTracks(AUDIO_TRACKS);
  }, []);

  return tracks;
}

export function formatTime(seconds: number): string {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins}:${secs.toString().padStart(2, '0')}`;
}